export default __webpack_public_path__ + "static/media/component-82-2@2x.59293173.png";